export const currencySymbolMap = {
  KRW: '₩',
  JPY: '¥',
  TWD: 'NT$'
}
